import React, { useState, useEffect } from 'react';
import { BodyMetrics, IconButton, ObjViewer } from '../../components';
import { ReactComponent as Button360 } from '../../styles/svg-components/360-icon.svg';
import { getRuns, getRun } from '../../services/measureSvc';
import {baseUrl} from '../../services/httpSvc';
import withAuth from '../../higherOrderComponents/withAuth'

import './Home.scss';

const loadRuns = async () => {
  try {
    const response = await getRuns();
    return response.data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

const loadRun = async (runId) => {
  try {
    const response = await getRun(runId);
    return response.data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

const HomePage = () => {
  const [run, setRun] = useState({});

  useEffect(() => {
    console.log('HomePage loaded...')
    setTimeout(async () => {
      const runs = await loadRuns();
      if (runs && runs.length > 0) {
        runs.sort((a, b) => b.id - a.id);
        const runId = runs[0].id;
        console.log('Load runID: ' + runId);
        const runDetails = await loadRun(runId);
  
        if (runDetails && runDetails.run && runDetails.data && runDetails.data.length > 0) {
          const measurements = runDetails.data[0].measurements;
          const mesh = runDetails.data[0].meshes[0];
  
          const model = {
            rootUrl: `${baseUrl}meshes/`,
            sceneFilename: `${mesh.id}.obj`,
          };
  
          const run = runDetails.run;
          setRun({ run: run, measurements: measurements, model: model });
        } else {
          setRun({
            model: {
              rootUrl: `/images/`,
              sceneFilename: 'Mesh-apose.obj',
            },
          });
        }
      }
    });
  }, []);

  return (
    <div className="home">
      <div className="info-panel">
        <IconButton icon={() => <Button360></Button360>}></IconButton>
      </div>

      {!!run && !!run.model && <div className="canvas-wrapper">
        &nbsp;
        <ObjViewer model={run.model} />
      </div>}

      <div className="info-panel">
        <BodyMetrics measurements={run.measurements}></BodyMetrics>
      </div>
    </div>
  );
};

export default withAuth(HomePage);
